export const customMessages = {
  'nome': {
    'string.base': '(Nome) deve ser um texto',
    'string.empty': '(Nome) é um campo obrigatório',
    'string.min': '(Nome) deve ter no mínimo 3 caracteres',
    'string.max': '(Nome) deve ter no máximo 100 caracteres',
    'any.required': '(Nome) é um campo obrigatório',
  },
  'cidade': {
    'string.base': '(Cidade) deve ser um texto',
    'string.empty': '(Cidade) deve ser um texto',
    'string.min': '(Cidade) deve ter no mínimo 3 caracteres',
    'string.max': '(Cidade) deve ter no máximo 100 caracteres',
    'any.required': '(Cidade) é um campo obrigatório',
  },
  'uf': {
    'string.base': '(UF) deve ser um texto',
    'string.empty': '(UF) é um campo obrigatório',
    'string.min': '(UF) deve ter no mínimo 2 caracteres',
    'string.max': '(UF) deve ter no máximo 2 caracteres',
    'any.required': '(UF) é um campo obrigatório',
  },
  'cep': {
    'string.empty': '(CEP) é um campo obrigatório',
    'string.min': '(CEP) inválido',
    'string.max': '(CEP) inválido',
    'any.required': '(CEP) é um campo obrigatório',
  },
};